import React, { useEffect, useRef, useState } from "react";
import SwiperCore, {
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import AchievementsItem from "./AchievementsItem";
import { Swiper as SwiperInstance } from "swiper";
import { useLocation } from "react-router-dom";
import { SpeakersInfoBlock } from "./components/SpeakersInfoBlock";
import clsx from "clsx";

const infoBlock = [
  {
    title: "Ключевые направления",
    icon: "📍",
    description: "ЮВА, Ближний Восток, Куба, острова Индийского океана",
    descriptionClassName:
      "max-w-[210px] lg:max-w-[263px] xl:max-w-[237px] 2xl:max-w-[315px]",
  },
  {
    title: "Тематические дни",
    icon: "✈️",
    description: "Travel-технологии, авиа, страхование",
    descriptionClassName:
      "md:max-w-[177px] lg:max-w-[197px] xl:max-w-[199px] 2xl:max-w-[265px] 3xl:max-w-[410px]",
  },
  {
    title: "Новинки",
    icon: "🆕",
    description:
      "Свежие предложения, важные новости и эксклюзивы только для участников",
    descriptionClassName:
      "max-w-[228px] lg:max-w-[290px] xl:max-w-[258px] 2xl:max-w-[347px] 3xl:max-w-[437px]",
  },
];

const localSlides: {
  id: number;
  name: string;
  text: string;
  image: string;
  imageWebp: string;
  imageCircle: string;
  imageCircleWebp: string;
  textAbout?: string;
  achievements?: string[];
  sort: number;
}[] = [
  {
    id: 1,
    name: "Токио Алимбекова",
    text: "представитель семейного курорта Centara Mirage Beach Resort Dubai",
    image: "speaker-1.jpeg",
    imageWebp: "speaker-1.jpeg",
    imageCircle: "speaker-1-icon.png",
    imageCircleWebp: "speaker-1-icon.png",
    sort: 0,
  },
  {
    id: 2,
    name: "Дмитрий Арутюнов",
    text: "генеральный директор ТО «Арт-тур»",
    image: "speaker-2.jpg",
    imageWebp: "speaker-2.jpg",
    imageCircle: "speaker-2-icon.png",
    imageCircleWebp: "speaker-2-icon.png",
    sort: 1,
  },
  {
    id: 3,
    name: "Алима Кожахметова",
    text: "старший менеджер по продажам Hilton Dubai Palm Jumeirah",
    image: "speaker-3.jpg",
    imageWebp: "speaker-3.jpg",
    imageCircle: "speaker-3-icon.png",
    imageCircleWebp: "speaker-3-icon.png",
    sort: 2,
  },
  {
    id: 4,
    name: "Артур Мурадян",
    text: "генеральный директор ТО Space Travel",
    image: "speaker-4.jpg",
    imageWebp: "speaker-4.jpg",
    imageCircle: "speaker-4-icon.png",
    imageCircleWebp: "speaker-4-icon.png",
    sort: 3,
  },
  {
    id: 5,
    name: "Дмитрий Морозов",
    text: "директор Национального агентства по туризму Республики Беларусь",
    image: "speaker-5.jpg",
    imageWebp: "speaker-5.jpg",
    imageCircle: "speaker-5-icon.png",
    imageCircleWebp: "speaker-5-icon.png",
    sort: 4,
  },
  {
    id: 6,
    name: "Юлия Кулова",
    text: "руководитель отдела продаж DMC Grand Tour Japan",
    image: "speaker-6.jpeg",
    imageWebp: "speaker-6.jpeg",
    imageCircle: "speaker-6-icon.png",
    imageCircleWebp: "speaker-6-icon.png",
    sort: 5,
  },
  {
    id: 7,
    name: "Любовь Чучмаева",
    text: "заместитель генерального директора по маркетингу и продвижению ТО Пакс",
    image: "speaker-7.jpg",
    imageWebp: "speaker-7.jpg",
    imageCircle: "speaker-7-icon.jpg",
    imageCircleWebp: "speaker-7-icon.jpg",
    sort: 6,
  },
  {
    id: 8,
    name: "Ася Сумбатянц",
    text: "менеджер по продажам SEA Company",
    image: "speaker-8.jpg",
    imageWebp: "speaker-8.jpg",
    imageCircle: "speaker-8-icon.jpg",
    imageCircleWebp: "speaker-8-icon.jpg",
    sort: 7,
  },
  {
    id: 9,
    name: "Алексей Пустовалов",
    text: "CEO туроператорского направления Travelata",
    image: "speaker-9.jpg",
    imageWebp: "speaker-9.jpg",
    imageCircle: "speaker-9-icon.jpg",
    imageCircleWebp: "speaker-9-icon.jpg",
    sort: 8,
  },
  {
    id: 10,
    name: "Анна Дайнеко",
    text: "заместитель директора по продажам отелей комплекса  Mina Seyahi Dubai",
    image: "speaker-10.jpg",
    imageWebp: "speaker-10.jpg",
    imageCircle: "speaker-10-icon.jpg",
    imageCircleWebp: "speaker-10-icon.jpg",
    sort: 9,
  },
];

const Speakers: React.FC = () => {
  const location = useLocation();
  const ref = useRef<SwiperInstance | null>(null);
  const anchorRef = useRef(null);
  const [activeButtonIndex, setActiveButtonIndex] = useState(0);

  SwiperCore.use([Autoplay, EffectFade, Navigation, Pagination]);

  const goToSlide = (index: number) => {
    if (ref.current) {
      ref.current.slideTo(index);
    }
  };

  useEffect(() => {
    const anchor = new URLSearchParams(location.search).get("anchor");
    if (anchor === "speakers" && anchorRef) {
      anchorRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location, anchorRef]);

  return (
    <section
      id="speakers"
      className="bg-grey-f5 pt-[56px] md:pt-[64px] lg:pt-[100px] 2xl:pt-[120px] 3xl:pt-[140px]"
      ref={anchorRef}
    >
      <div className="cont flex flex-col gap-10 lg:gap-16 2xl:gap-[60px] 3xl:gap-[80px]">
        <div className="flex flex-col gap-6 w-full">
          <p className="title-middle w-fit !leading-[125%] md:!leading-[120%] lg:!leading-[110%]">
            Зима <span className="text-red-500">25/26</span>
          </p>
          <p className="text-16 lg:text-24 !leading-[130%] !leading-[125%] md:!leading-[130%] lg:!leading-[125%]">
            Всё о сезоне на одной площадке: эфиры с НТО, ТО, DMC,
            <br className="hidden lg:block xl:hidden" /> отелями и
            авиакомпаниями
          </p>
        </div>

        <SpeakersInfoBlock className="md:hidden" infoBlock={infoBlock} />

        <div className="md:flex md:justify-between md:pb-16 lg:pb-[100px] 2xl:pb-[120px] 3xl:pb-[140px] md:gap-10">
          <div
            className={clsx(
              "hidden justify-between pb-10",
              "md:flex md:flex-col md:pb-0",
              "3xl:min-w-[432px]"
            )}
          >
            <SpeakersInfoBlock
              className="hidden md:flex"
              infoBlock={infoBlock}
            />

            <div className="lg:flex gap-0.5 flex-wrap">
              {localSlides.map((item, index) => (
                <picture
                  key={index}
                  className={clsx(
                    "h-[65px] w-[65px] md:h-[35px] md:w-[35px] lg:h-[45px] lg:w-[45px] 2xl:h-[50px] 2xl:w-[50px]",
                    "rounded-full cursor-pointer"
                  )}
                  onClick={() => goToSlide(index + 1)}
                >
                  <source
                    srcSet={require(`@public/images/slider/${item.imageCircleWebp}`)}
                    type="image/webp"
                  />
                  <img
                    src={require(`@public/images/slider/${item.imageCircle}`)}
                    alt="Спикер"
                    className={clsx(
                      "w-full h-full rounded-full object-cover",
                      activeButtonIndex === index + 1 &&
                        "outline-2 outline outline-red-500"
                    )}
                  />
                </picture>
              ))}
            </div>
          </div>
          <Swiper
            onSlideChange={(swiper) => {
              setActiveButtonIndex(swiper.activeIndex);
            }}
            breakpoints={{
              768: {
                simulateTouch: false,
                allowTouchMove: false,
                keyboard: false,
                mousewheel: false,
              },
            }}
            spaceBetween={50}
            slidesPerView={1}
            fadeEffect={{ crossFade: true }}
            effect={"fade"}
            pagination={{
              clickable: true,
              type: "bullets",
            }}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            centeredSlides={true}
            className="speakers-slider mt-0 !mx-0 md:!mr-[35px] lg:!mr-0 md:max-w-[280px] lg:max-w-[456px] xl:max-w-[645px] 2xl:max-w-[755px] 3xl:max-w-[843px] 4xl:max-w-[873px]"
            onSwiper={(swiper) => {
              ref.current = swiper;
            }}
            observer={true}
            observeParents={true}
          >
            {localSlides?.map((slide) => {
              return (
                <SwiperSlide className="swiper-container" key={slide.id}>
                  <div className="bg-white rounded-xl flex flex-col xl:flex-row max-w-[1025px] h-full xl:gap-[34px] 2xl:gap-10">
                    <picture
                      className={clsx(
                        "overflow-hidden rounded-xl h-[320px] w-full",
                        "md:h-[255px]",
                        "lg:w-[456px] lg:h-[295px]",
                        "xl:w-[291px] xl:h-[449px]",
                        "2xl:w-[362px] 2xl:h-[510px]",
                        "3xl:w-[405px]",
                        "4xl:w-[419px]"
                      )}
                    >
                      {slide.id === 1 && (
                        <source
                          media="(width: 1024px)"
                          srcSet={require("@public/images/slider/speaker-1-1024.png")}
                          type="image/png"
                        />
                      )}
                      <source
                        srcSet={require(`@public/images/slider/${slide?.imageWebp}`)}
                        type="image/webp"
                      />
                      <img
                        src={require(`@public/images/slider/${slide?.image}`)}
                        alt="Спикер"
                        className="w-full h-full object-cover object-top block"
                      />
                    </picture>

                    <div
                      className={clsx(
                        "flex flex-col flex-1 justify-between h-auto rounded-b-xl px-[10px] py-8 gap-5",
                        "md:px-5",
                        "lg:gap-10",
                        "xl:pr-10 xl:py-10 xl:px-0 xl:gap-0",
                        "2xl:pr-[40px] 2xl:py-10"
                      )}
                    >
                      <div className="flex flex-col gap-5 lg:gap-8">
                        <p className="text-2xl !leading-[125%] font-bold md:text-lg lg:text-20 xl:text-24 2xl:text-36">
                          {slide.name}
                        </p>

                        {slide.textAbout && (
                          <p className="!leading-[130%] md:text-14 2xl:text-24">
                            {slide.textAbout}
                          </p>
                        )}
                      </div>

                      <div className="lg:justify-between flex gap-5 lg:gap-8 flex-col">
                        {slide?.achievements && (
                          <div className="flex gap-2 flex-col lg:gap-3">
                            <AchievementsItem
                              achievements={slide?.achievements}
                            />
                          </div>
                        )}

                        <div
                          className="!leading-[130%] md:text-14 lg:text-16 xl:text-18 2xl:text-24"
                          dangerouslySetInnerHTML={{ __html: slide.text }}
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Speakers;
